import { TYPES } from "./supporter.type";

const initState = {
  supporter: null,
};

const supporterReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_SUPPORTER_SUCCESS:
      return {
        ...state,
        supporter: payload,
      };

    default:
      return state;
  }
};

export default supporterReducer;
